import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean | UrlTree> {
    if (!this.auth.isLoggedIn) { return this.router.createUrlTree(['/login']); }
    if (this.auth.isAdmin) { return true; }

    // The Reseller Blueprint promises "deactivating a reseller record
    // instantly revokes access — no credential rotation needed." That was
    // only ever checked once, right after a fresh Google OAuth redirect
    // (AuthService.consumeRedirectResult) — a reseller who was already
    // signed in (existing browser session, no fresh redirect) kept full
    // access after being deactivated, since nothing re-checked `active` on
    // ordinary navigation. Re-verifying here, on every route activation,
    // is what actually makes deactivation instant.
    const active = await this.auth.isActiveReseller();
    if (!active) {
      await this.auth.logout();
      return this.router.createUrlTree(['/login']);
    }
    return true;
  }
}
